export default __webpack_public_path__ + "static/media/notification-16px.95038bde.svg";